import axios from 'axios'
import router from '../router'

// Create axios instance with default config
const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:8000',
  withCredentials: false, // Using token-based auth, not session cookies
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
})

// Request interceptor - attach Bearer token if exists
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor - handle errors globally
axiosInstance.interceptors.response.use(
  (response) => {
    // Success response - optionally show toast for mutations
    const method = response.config.method?.toUpperCase()
    if (['POST', 'PUT', 'PATCH', 'DELETE'].includes(method)) {
      // You can add toast notification here if needed
      console.log('Success:', response.data)
    }
    return response
  },
  (error) => {
    if (error.response) {
      const status = error.response.status

      switch (status) {
        case 401:
          // Unauthorized / session expired - clear auth state directly to avoid
          // circular dependency (axios ↔ stores/auth) that breaks Pinia 3 internals
          localStorage.removeItem('auth_token')
          localStorage.removeItem('user')
          if (router.currentRoute.value.name !== 'login') {
            router.push({ name: 'login' })
          }
          break

        case 403:
          // Forbidden - user doesn't have permission
          console.error('Forbidden: You do not have permission to access this resource')
          if (error.response.data?.code === 'MODULE_ACCESS_DENIED') {
            window.dispatchEvent(new CustomEvent('module-access-denied', {
              detail: { module: error.response.data.module },
            }))
          }
          break

        case 422:
          // Validation errors - will be handled by the component
          console.log('Validation errors:', error.response.data.errors)
          break

        case 500:
          // Server error
          console.error('Server error:', error.response.data.message)
          break

        default:
          console.error('Error:', error.response.data.message || 'An error occurred')
      }
    } else if (error.request) {
      // Network error - no response received
      console.error('Network error: No response from server')
    } else {
      // Something else happened
      console.error('Error:', error.message)
    }

    return Promise.reject(error)
  }
)

export default axiosInstance
